
import { BlogArticlesMap } from '@/types/BlogArticle';
import { article as kiVideomarketing } from './ki-videomarketing-revolution-schweiz-2025';
import { article as aiErklaervideos } from './5-vorteile-ai-erklaervideos-unternehmen';
import { article as videomarketing2025 } from './videomarketing-trends-2025';
import { article as aiVsKlassisch } from './ai-vs-klassische-videoproduktion-kostenvergleich';
import { article as kiMyths } from './ki-videoproduktion-mythen';
import { article as kiStorytelling } from './ki-storytelling-videos-veraendert';
import { article as ecommerceVideo } from './videomarketing-ecommerce-ki-produktvideos';
import { article as contentMitKi } from './content-mit-ki-skalieren';
import { article as kiSocialMedia } from './ki-social-media-video-content';
import { article as kiVideoKosten } from './ki-video-kosten-nutzen-erklaert';
import { article as kiVideoIndividuell } from './ki-video-individuell-markenkonform';
import { article as vorteileAiErklaervideos } from './vorteile-ai-erklaervideos';
import { article as zukunftWerbung } from './zukunft-werbung-ki-gamechanger';
import { article as coachesBeraterAiVideos } from './coaches-berater-ai-videos';
import { article as klinikenPraxenAiVideos } from './kliniken-praxen-ai-videos';
import { websiteKostenSchweiz2025 } from './website-kosten-schweiz-2025';
import { googleBewertungenSchweizRechtssicher } from './google-bewertungen-schweiz-rechtssicher';
import { multilingualesSeoHreflangSchweiz } from './multilinguales-seo-hreflang-schweiz';
import { shopifySchweizTwintPostfinance } from './shopify-schweiz-twint-postfinance';

// Create a map of all blog articles
export const blogArticles: BlogArticlesMap = {
  "ki-videomarketing-revolution-schweiz-2025": kiVideomarketing,
  "5-vorteile-ai-erklaervideos-unternehmen": aiErklaervideos,
  "videomarketing-trends-2025": videomarketing2025,
  "ai-vs-klassische-videoproduktion-kostenvergleich": aiVsKlassisch,
  "ki-videoproduktion-mythen": kiMyths,
  "ki-storytelling-videos-veraendert": kiStorytelling,
  "videomarketing-ecommerce-ki-produktvideos": ecommerceVideo,
  "content-mit-ki-skalieren": contentMitKi,
  "ki-social-media-video-content": kiSocialMedia,
  "ki-video-kosten-nutzen-erklaert": kiVideoKosten,
  "ki-video-individuell-markenkonform": kiVideoIndividuell,
  "vorteile-ai-erklaervideos": vorteileAiErklaervideos,
  "zukunft-werbung-ki-gamechanger": zukunftWerbung,
  "coaches-berater-ai-videos": coachesBeraterAiVideos,
  "kliniken-praxen-ai-videos": klinikenPraxenAiVideos,
  "website-kosten-schweiz-2025": websiteKostenSchweiz2025,
  "google-bewertungen-schweiz-rechtssicher": googleBewertungenSchweizRechtssicher,
  "multilinguales-seo-hreflang-schweiz": multilingualesSeoHreflangSchweiz,
  "shopify-schweiz-twint-postfinance": shopifySchweizTwintPostfinance,
};

// Helper function to get all articles as an array
export const getAllArticles = () => {
  return Object.values(blogArticles);
};

// Helper function to get recent articles
export const getRecentArticles = (count: number = 3) => {
  return getAllArticles()
    .sort((a, b) => {
      const dateA = new Date(a.date.split('.').reverse().join('-'));
      const dateB = new Date(b.date.split('.').reverse().join('-'));
      return dateB.getTime() - dateA.getTime();
    })
    .slice(0, count);
};

// Helper function to get article by slug
export const getArticleBySlug = (slug: string) => {
  return blogArticles[slug];
};

// Industry classification for content clusters
export const articleIndustries = {
  ecommerce: ["videomarketing-ecommerce-ki-produktvideos", "ki-video-individuell-markenkonform", "shopify-schweiz-twint-postfinance"],
  healthcare: ["kliniken-praxen-ai-videos"],
  finance: [],
  coaching: ["coaches-berater-ai-videos"],
  webdesign: ["website-kosten-schweiz-2025"],
  marketing: ["google-bewertungen-schweiz-rechtssicher"],
  seo: ["multilinguales-seo-hreflang-schweiz"],
  general: ["ki-videomarketing-revolution-schweiz-2025", "5-vorteile-ai-erklaervideos-unternehmen", 
            "videomarketing-trends-2025", "ai-vs-klassische-videoproduktion-kostenvergleich", 
            "ki-videoproduktion-mythen", "ki-storytelling-videos-veraendert", "content-mit-ki-skalieren",
            "ki-social-media-video-content", "ki-video-kosten-nutzen-erklaert", "vorteile-ai-erklaervideos",
            "zukunft-werbung-ki-gamechanger"]
};

// Topics classification for internal linking
export const articleTopics = {
  cost: ["ai-vs-klassische-videoproduktion-kostenvergleich", "ki-video-kosten-nutzen-erklaert", "website-kosten-schweiz-2025"],
  social: ["ki-social-media-video-content"],
  explainer: ["5-vorteile-ai-erklaervideos-unternehmen", "vorteile-ai-erklaervideos"],
  trends: ["videomarketing-trends-2025", "zukunft-werbung-ki-gamechanger"],
  storytelling: ["ki-storytelling-videos-veraendert"],
  myths: ["ki-videoproduktion-mythen"],
  scaling: ["content-mit-ki-skalieren"],
  branding: ["ki-video-individuell-markenkonform"],
  reviews: ["google-bewertungen-schweiz-rechtssicher"],
  pricing: ["website-kosten-schweiz-2025"],
  seo: ["multilinguales-seo-hreflang-schweiz"],
  ecommerce: ["shopify-schweiz-twint-postfinance"]
};

// Long-tail keyword mapping for SEO
export const articleKeywords = {
  "ki-videomarketing-revolution-schweiz-2025": [
    "KI Videomarketing Schweiz", 
    "AI Video Marketing Trends 2025",
    "KI Video Produktion Kosten Schweiz",
    "künstliche Intelligenz Werbevideos"
  ],
  "5-vorteile-ai-erklaervideos-unternehmen": [
    "AI Erklärvideos für Unternehmen",
    "Vorteile KI Videos Geschäft",
    "automatisierte Erklärvideos Produktion",
    "KI gestützte Unternehmensvideos"
  ],
  "videomarketing-ecommerce-ki-produktvideos": [
    "E-Commerce Produktvideos mit KI",
    "Online-Shop Conversion KI Videos",
    "AI Produktvideos für Webshops",
    "automatisierte E-Commerce Videoproduktion"
  ],
  "ki-social-media-video-content": [
    "KI Videos Social Media Kampagnen",
    "AI Video Content Marketing",
    "KI Reels und Shorts erstellen",
    "Social Media Video Automation"
  ],
  "kliniken-praxen-ai-videos": [
    "KI Videos für Gesundheitswesen",
    "AI Erklärvideos für Mediziner",
    "Patientenkommunikation mit KI Videos",
    "medizinische Erklärvideos KI-generiert"
  ],
  "coaches-berater-ai-videos": [
    "KI Videomarketing für Coaches",
    "AI Videos für Berater und Trainer",
    "Coaching Business Videomarketing",
    "personalisierte KI Videos Beratung"
  ],
  // We can expand this with more keyword mappings for other articles
  "ki-video-individuell-markenkonform": [
    "individuelle KI Videos Corporate Design",
    "markenspezifische AI Videoproduktion",
    "KI Videos Markenidentität",
    "personalisierte Videoerstellung KI"
  ],
  "ki-video-kosten-nutzen-erklaert": [
    "KI Video ROI Analyse",
    "Kosten-Nutzen AI Videomarketing",
    "KI Video Investition lohnenswert",
    "Wirtschaftlichkeit KI Videoproduktion"
  ]
};

// Helper function to get related articles by industry
export const getRelatedArticlesByIndustry = (slug: string, count: number = 2) => {
  // Find which industry this article belongs to
  const industry = Object.keys(articleIndustries).find(
    ind => articleIndustries[ind as keyof typeof articleIndustries].includes(slug)
  ) || "general";
  
  // Get other articles from the same industry
  const sameIndustryArticles = articleIndustries[industry as keyof typeof articleIndustries]
    .filter(articleSlug => articleSlug !== slug)
    .map(articleSlug => blogArticles[articleSlug]);
  
  return sameIndustryArticles.slice(0, count);
};

// Helper function to get related articles by topic
export const getRelatedArticlesByTopic = (slug: string, count: number = 2) => {
  // Find which topics this article belongs to
  const topics = Object.keys(articleTopics).filter(
    topic => articleTopics[topic as keyof typeof articleTopics].includes(slug)
  );
  
  // Get all article slugs from these topics, excluding the current one
  const relatedSlugs = topics.flatMap(
    topic => articleTopics[topic as keyof typeof articleTopics]
  ).filter(articleSlug => articleSlug !== slug);
  
  // Remove duplicates and get the article objects
  const uniqueSlugs = [...new Set(relatedSlugs)];
  const relatedArticles = uniqueSlugs.map(articleSlug => blogArticles[articleSlug]);
  
  return relatedArticles.slice(0, count);
};
